import { NO_ERRORS_SCHEMA } from '@angular/core';

import { initialModule, ModuleMetadata } from '../base/initial-module';
import { SpecDirectiveOptions } from './options';

/**
 * @internal
 */
export function initialSpecDirectiveModule<D, H>(options: Required<SpecDirectiveOptions<D, H>>): ModuleMetadata {
  const moduleMetadata = initialModule(options);

  if (options.declareDirective) {
    moduleMetadata.declarations.push(options.directive);
  }
  moduleMetadata.declarations.push(options.host);

  moduleMetadata.schemas = [options.shallow ? NO_ERRORS_SCHEMA : options.schemas || []];

  return moduleMetadata;
}
